import { Layout } from 'antd'
import { FC, ReactNode } from 'react'
import Styles from './layout.module.scss'

interface Props {
    children: ReactNode
    avatar?: string
    headerText?: string
    headerLogo?: string
    isSeasonHeaderHidden?: boolean
}
const { Content } = Layout

export const LeaderBoardLayout: FC<Props> = ({ children }) => {
    return (
        <Layout
            className={Styles.container}
            style={{
                backgroundColor:
                    window.localStorage.getItem('TRANSPARENT') === 'transparent'
                        ? 'transparent'
                        : '#090916',
            }}
        >
            <Content> {children}</Content>
        </Layout>
    )
}
